<div class="modal-padding">
  <lib-reactive-form-group [bindTo]="bindTo" [mergeKey]="mergeKey">
    <div class="title-row">
      <div class="form-input-title mb-2">Info</div>
    </div>

    <lib-reactive-form-column-layout [nColumns]="2">
      <lib-reactive-form-text
        [inputName]="'smartFilterName'"
        [label]="'Smart Filter Name'"
        [placeholder]="'My Smart Filter'"
        [inlineLabel]="false"
        [required]="true"
        [maxLength]="128"
        [disabled]="viewModel.isViewOnly$ | async"
        [bindingProperty]="'name'"
        [dispersedKey]="mergeKey">
      </lib-reactive-form-text>

      <lib-reactive-form-number
        [inputName]="'itemCount'"
        [label]="'Item Count'"
        [placeholder]="'Enter an item count'"
        [inlineLabel]="false"
        [minValue]="1"
        [integersOnly]="true"
        [disabled]="viewModel.isViewOnly$ | async"
        [bindingProperty]="'itemCount'"
        [dispersedKey]="mergeKey"
        (valueChanged)="viewModel.setItemCount($event)">
      </lib-reactive-form-number>

      <lib-reactive-form-searchable-drop-down
        #primarySort
        [inputName]="'primarySort'"
        [label]="'Primary Sort'"
        [placeholder]="'Select a primary sort'"
        [searchPlaceholder]="'Search sort options'"
        [inlineLabel]="false"
        [required]="(viewModel.itemCount$ | push) > 0"
        [clearable]="!(viewModel.isViewOnly$ | async)"
        [useClearableButton]="false"
        [disabled]="viewModel.disableSortDropdowns$ | async"
        [dropdowns]="viewModel.primarySortDropdownOptions$ | async"
        [dropdownGroupings]="viewModel.sortDropdownGroupings$ | async"
        [bindingProperty]="'primarySort'"
        [dispersedKey]="mergeKey"
        [tooltip]="viewModel.primarySortTooltip$ | async"
        (valueChanged)="primarySortDropdownChanged($event)">
      </lib-reactive-form-searchable-drop-down>

      <lib-reactive-form-searchable-drop-down
        #secondarySort
        [inputName]="'secondarySort'"
        [label]="'Secondary Sort'"
        [placeholder]="'Select a secondary sort'"
        [searchPlaceholder]="'Search sort options'"
        [inlineLabel]="false"
        [required]="(viewModel.itemCount$ | push) > 0"
        [clearable]="!(viewModel.disableSecondarySort$ | async)"
        [useClearableButton]="false"
        [disabled]="viewModel.disableSortDropdowns$ | async"
        [dropdowns]="viewModel.secondarySortDropdownOptions$ | async"
        [tooltip]="viewModel.secondarySortTooltip$ | async"
        [dropdownGroupings]="viewModel.sortDropdownGroupings$ | async"
        [bindingProperty]="'secondarySort'"
        [dispersedKey]="mergeKey">
      </lib-reactive-form-searchable-drop-down>

      <div [style.display]="'flex'" [style.gap.rem]="0.5">
        <lib-reactive-form-searchable-drop-down
          #categoryDropDown
          class="flex-grow-1"
          [inputName]="'smartFilterCategory'"
          [label]="'Parent Group'"
          [placeholder]="'Select a filter group'"
          [searchPlaceholder]="'Search filter groups'"
          [inlineLabel]="false"
          [disabled]="false"
          [required]="true"
          [dropdowns]="dropdownSmartFilterCategories$ | push"
          [programmaticallyChangeValue]="programmaticCategoryId$ | push"
          [bindingProperty]="'categoryId'"
          [clearable]="true"
          [useClearableButton]="false">
        </lib-reactive-form-searchable-drop-down>
        <lib-button-primary class="mt-4" (buttonClicked)="newCategoryClicked()">New</lib-button-primary>
      </div>

      <lib-reactive-form-searchable-drop-down
        [inputName]="'smartFilterSystemIdentifier'"
        [label]="'System Identifier'"
        [placeholder]="'--'"
        [dropdowns]="dropdownSmartFilterSystemIdentifiers$ | push"
        [bindingProperty]="'systemIdentifier'"
        [disabled]="true"></lib-reactive-form-searchable-drop-down>

      <lib-reactive-form-switch
        class="mt-2"
        [style.align-self]="'center'"
        [label]="'This is an Advanced Curated Smart Filter'"
        [bindingProperty]="'advancedFilter'"
        [inputName]="'advancedFilter'">
      </lib-reactive-form-switch>

      <lib-reactive-form-switch
        class="mt-2"
        [style.align-self]="'center'"
        [label]="'This is a Hidden Smart Filter.'"
        [bindingProperty]="'hidden'"
        [inputName]="'hiddenFilter'"
        [tooltip]="'Hidden smart filters will not appear within the smart filter modal'">
      </lib-reactive-form-switch>
    </lib-reactive-form-column-layout>

    <app-warning-banner *ngIf="viewModel.hasSystemIdentifier$ | push" [style.margin-top.rem]="1">
      This Smart Filter has a system identifier associated and is used in automatic menus and flows. Any changes made
      may break system functionality - proceed with caution.
    </app-warning-banner>
    <hr />
  </lib-reactive-form-group>
</div>
